// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import requestReminderEntity from './entities/request-reminder.json';
import requestReminderMenu from '../pages/request-reminder/menu.json';
import requestReminderFullForm from '../pages/request-reminder/forms/full.json';
import requestReminderContextForm from '../pages/request-reminder/forms/context.json';
import requestReminderMiniForm from '../pages/request-reminder/forms/mini.json';
import requestReminderLookupForm from '../pages/request-reminder/forms/lookup.json';
import requestReminderTableView from '../pages/request-reminder/views/table.json';
import requestReminderCardsView from '../pages/request-reminder/views/cards.json';
import requestReminderCalendarView from '../pages/request-reminder/views/calendar.json';
import requestReminderDashboardView from '../pages/request-reminder/views/dashboard.json';

/** Тип запису «Нагадування» зі сторінками пакета: меню, форми та подання з pages/request-reminder/. */
export const requestReminderDefinition: IRecordTypeDefinition = {
  ...requestReminderEntity,
  views: assembleViewSet({
      table: requestReminderTableView,
      cards: requestReminderCardsView,
      calendar: requestReminderCalendarView,
      dashboard: requestReminderDashboardView,
  }),
  form: requestReminderFullForm,
  forms: { full: requestReminderFullForm, context: requestReminderContextForm, mini: requestReminderMiniForm, lookup: requestReminderLookupForm },
  menu: requestReminderMenu,
} as IRecordTypeDefinition;
